import { useEffect, useRef, useState } from "react";

export const useIntersect = ({ root = null, rootMargin = "0px", threshold = 0 }: IntersectionObserverInit) => {
    const [entry, updateEntry] = useState<IntersectionObserverEntry>();
    const [node, setNode] = useState<HTMLElement | null>(null);

    const observer = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new window.IntersectionObserver(([entry]) => updateEntry(entry), {
            root,
            rootMargin,
            threshold
        });
        const { current: currentObserver } = observer;
        currentObserver.disconnect();

        if (node) currentObserver.observe(node);

        return () => currentObserver.disconnect();
    }, [node]);

    return { setNode, entry };
};
